import React, { useState } from 'react';
import {
  Container,
  Col,
  Icons,
  mediaQueries,
  SideDrawerItem,
} from '@everlywell/leaves';
import { TabMenu } from '../../TabMenu';
import useMediaQuery from 'utils/useMediaQuery';

import MobileFilterMenu from './MobileFilterMenu';

import * as S from './styles';

export type PageControlSectionProps = {
  handleCategorySelect: (categoryIndex: number) => void;
  allTabItems: string[];
  categoryIndex: number;
  numberOfResults: number;
};

export const PageControlSection: React.FC<PageControlSectionProps> = ({
  handleCategorySelect,
  allTabItems,
  categoryIndex,
  numberOfResults,
}) => {
  const [showFilterDrawer, setShowFilterDrawer] = useState<boolean>(false);

  const handleCategoryClick = (i: number) => {
    handleCategorySelect(i);
    setTimeout(() => {
      setShowFilterDrawer(false);
    }, 500);
  };

  const isTabletUp = useMediaQuery(mediaQueries.forTabletHorizontalUp);

  return (
    <Container>
      <S.Row center="xs" middle="sm">
        {isTabletUp ? (
          <S.TabMenuWrapper xs={12}>
            <TabMenu
              items={allTabItems}
              onItemSelect={handleCategorySelect}
              activeIndex={categoryIndex}
              ariaLabel="Product Category Filter"
              ariaControls="productGrid"
            />
          </S.TabMenuWrapper>
        ) : (
          <S.TabMenuWrapper xs={12} />
        )}
        <Col xs={12} sm={6}>
          <S.DisplayTitle data-testid="pipSelectedCategory">
            {allTabItems[categoryIndex]}
          </S.DisplayTitle>
        </Col>
        <S.MobileFilter xs={12} sm={6}>
          <S.SideDrawerItemWrapper>
            <S.NumberOfResults>{numberOfResults} results</S.NumberOfResults>
            {!isTabletUp ? (
              <S.SideDrawerTrigger>
                <SideDrawerItem
                  active={showFilterDrawer}
                  icon={<Icons.Refine />}
                  label="Filter &amp; Sort"
                  onClickHandler={() => setShowFilterDrawer(!showFilterDrawer)}
                  handleClose={() => setShowFilterDrawer(false)}
                  drawerChildren={
                    <MobileFilterMenu
                      categories={allTabItems}
                      onItemSelect={handleCategoryClick}
                      activeIndex={categoryIndex}
                      ariaLabel="Product Category Filter"
                      ariaControls="productGrid"
                    />
                  }
                />
              </S.SideDrawerTrigger>
            ) : null}
          </S.SideDrawerItemWrapper>
        </S.MobileFilter>
      </S.Row>
    </Container>
  );
};

export default PageControlSection;
